import "./unlock-customer.scss";

import { useQyUnlockPerson } from "@factory/query/person.query";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import useScreenSize from "@shared/utility/screen-size";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputOtp } from "primereact/inputotp";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { appFeature } from "../../../app.feature";

export interface UnlockCustomerProps {}

export function UnlockCustomer() {
  // DECLARATIONS
  const { showSuccess } = useNotificationContext();
  const customerPasscodeLength = appFeature.config.password.pinLength ?? 6;
  const navigate = useNavigate();
  const { isMobileMode } = useScreenSize();
  const [password, setPassword] = useState<string>("");
  const { personId } = useParams();

  // API DEFINITIONS
  const handleUnlockSuccess = () => {
    handleBack();
    showSuccess("Customer unlocked");
  };
  const { mutate: unlock } = useQyUnlockPerson(handleUnlockSuccess);

  // LOCAL FUNCTIONS
  const handleBack = () => {
    navigate("../");
  };
  const handleSave = () => {
    if (!personId || !password) {
      return;
    }

    unlock({
      code: personId,
      password,
    });
  };

  // LOCAL RENDERS
  const headerElement = (
    <div className="flex flex-col items-center justify-center gap-2">
      <span className="font-bold white-space-nowrap">Unlock Account</span>
    </div>
  );
  const footerElement = (
    <div className="flex flex-col gap-2">
      <Button label="Save" autoFocus onClick={() => handleSave()} />
      <Button
        label="Close"
        severity="secondary"
        outlined
        onClick={() => handleBack()}
      />
    </div>
  );

  return (
    <div id="UnlockCustomer" className="unlock-customer">
      <Dialog
        header={headerElement}
        footer={footerElement}
        visible={true}
        style={{ width: "50vw" }}
        onHide={() => handleBack()}
        closable={false}
        maximized={isMobileMode}
      >
        <div className="mt-4 flex items-center justify-center">
          <div>
            <label className="mb-2 block">Enter your new passcode</label>
            <InputOtp
              value={password}
              onChange={(e) => setPassword(e.value as string)}
              integerOnly={true}
              length={customerPasscodeLength}
              mask={true}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default UnlockCustomer;
